import React from "react";
import Layouts from "./layout/Layout";
import { Route, Routes } from "react-router-dom";
import OTP from "./pages/NotAuth/OTP";
import Asset from "./pages/NotAuth/Asset";
import LiffBasic from "./pages/NotAuth/LiffBasic";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Questionnaire from './pages/questionnaire/QuestionnaireMain';
import QuestionnaireSuccess from './pages/questionnaire/QuestionnaireSuccess';
import QuestionnaireNotFound from './pages/questionnaire/QuestionnaireNotFound';
import LoadingMain from './components/dialog/LoadingMain'
import ArticlePoint from "./pages/auth-redirect/ArticlePoint";
import QuizMania from "./pages/quiz-mania/QuizMania";
import QuizManiaRank from "./pages/quiz-mania/QuizManiaRank";
import QuestionnaireCatMain from "./pages/questionnaire/QuestionnaireMainCat";
import QuizManiaCat from "./pages/quiz-mania-cat/QuizMania";
import QuizManiaSuccess from "./pages/quiz-mania/QuizManiaSuccess";
import QuizManiaNotFound from "./pages/quiz-mania/QuestionnaireNotFound";
import QuizManiaRankCat from "./pages/quiz-mania-cat/QuizManiaRank";
import QuizManiaNotFoundCat from "./pages/quiz-mania-cat/QuizManiaNotFoundCat";
import QuizManiaSuccessCat from "./pages/quiz-mania-cat/QuizManiaSuccessCat";

const theme = createTheme({
  typography: {
    fontFamily: `'DB Helvethaica X', 'Kanit', sans-serif`,
    fontSize: 16,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
  },
});

function App() {

  return (
    <>
     <ThemeProvider theme={theme}>
          <Layouts>
            <LoadingMain/>
            <Routes>
              <Route path="/otp" element={<OTP />} />
              <Route path="/liff-basic" element={<LiffBasic />} />
              <Route path="/asset" element={<Asset />} />
              <Route path="/questionnaire" element={<Questionnaire />} />
              <Route path="/questionnaire-cat" element={<QuestionnaireCatMain />} />
              <Route path="/article-point" element={<ArticlePoint />} />
              <Route path="/quiz-mania" element={<QuizMania />} />
              <Route path="/quiz-mania-success" element={<QuizManiaSuccess />} />
              <Route path="/quiz-mania-rank" element={<QuizManiaRank />} />
              <Route path="/quiz-mania-not-found" element={<QuizManiaNotFound />} />
              <Route path="/quiz-mania-cat" element={<QuizManiaCat />} />
              <Route path="/redirect" element={<QuizMania />} />
              <Route path="/redirect-cat" element={<QuizManiaCat />} />
              <Route path="/quiz-mania-cat" element={<QuizManiaCat />} />
              <Route path="/quiz-mania-success-cat" element={<QuizManiaSuccessCat />} />
              <Route path="/quiz-mania-rank-cat" element={<QuizManiaRankCat />} />
              <Route path="/quiz-mania-not-found-cat" element={<QuizManiaNotFoundCat />} />
              t
            </Routes>
          </Layouts>
        </ThemeProvider>
    </>
  );
}

export default App;
